module.exports = __webpack_public_path__ + "static/media/DE.b55ae913.svg";